module.exports = __webpack_public_path__ + "img/sicooblogo.58b655bf.png";